import { apiRequest } from '@scc/lib'

/** Response of POST /auth/api-keys — `key` is the raw cc_sk_* secret, shown once. */
export interface CreatedApiKey {
  id: string
  name: string
  prefix: string
  key: string
  scopeType: 'store' | 'agency'
  storeId: number | null
  agencyId: number | null
  scopes: string[]
  expiresAt: string | null
  createdAt: string
}

export type ApiKeyScope = 'read' | 'ingestion:read' | 'ingestion:write'

export const apiKeysApi = {
  /** Mint a store-scoped API key (used by the AI-assistants CLI connector flow). */
  createStoreKey(input: {
    storeId: number
    name: string
    scopes: ApiKeyScope[]
  }): Promise<CreatedApiKey> {
    return apiRequest<CreatedApiKey>('/auth/api-keys', {
      method: 'POST',
      body: {
        name: input.name,
        scopeType: 'store',
        storeId: input.storeId,
        scopes: input.scopes,
      },
    })
  },
}
